<template>
  <!--Evento emitido quando o value do rating é alterado.
      @event input
      @property {Number} value - Indica o rating do componente quando o valor muda.
   -->
  <v-rating
    class="zoox-component"
    :value="value"
    :color="color"
    :background-color="backgroundColor"
    half-increments
    :size="size"
    :empty-icon="emptyIcon"
    :full-icon="fullIcon"
    :half-icon="halfIcon"
    :length="length"
    :hover="hover"
    :readonly="disabled"
    @input="$emit('input', $event)"
  >
  </v-rating>
</template>

<script>
/**
 * @displayName Rating
 */
export default {
  name: 'ZRating',
  model: {
    event: 'input',
  },

  props: {
    /**
     * Determina o valor do rating
     */
    value: {
      type: Number,
      default: 0,
    },
    /**
     * Cor que preenche os icons do rating.
     *
     */
    color: {
      type: String,
      required: false,
      default: 'var(--yellow)',
    },
    /**
     * Cor de fundo dos icons do rating.
     *
     */
    backgroundColor: {
      type: String,
      required: false,
      default: 'background',
    },
    /**
     * Permite a seleção de meio icon no rating
     */
    halfIncrements: {
      type: Boolean,
      required: false,
    },
    /**
     * Permite alterar o tamanho do icons do rating.
     */
    size: {
      type: [Number, String],
      default: 40,
    },
    /**
     * Permite escolher o icone que vai ser mostrado como vazio no rating.
     */
    emptyIcon: {
      type: String,
      default: '$star_border_rounded',
    },
    /**
     * Permite escolher o icone que vai ser mostrado como meio preenchido no rating.
     */
    halfIcon: {
      type: String,
      default: '$star_half_rounded',
    },
    /**
     * Permite escolher o icone que vai ser mostrado como cheio no rating.
     */
    fullIcon: {
      type: String,
      default: '$star_rounded',
    },
    /**
     * Quantidade de classificação para ser mostradono no rating.
     */
    length: {
      type: [Number, String],
      default: 5,
    },
    /**
     * Flag para Fornecer um feedback visual ao passar o mouse sobre os ícones.
     */
    hover: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para indicar que o campo deve ficar desabilitado
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style></style>
